import { TFunction } from 'i18next'
import { FieldType, IFormConfig } from 'types'

import {
  BeneficialOwnerForm,
  beneficialOwnerFormSchema
} from './beneficial-owner-schema'
import { BeneficialOwnerField } from 'components/BeneficialOwnerField'

export const getBeneficialOwnerConfig = (
  t: TFunction
): IFormConfig<BeneficialOwnerForm> => ({
  schema: beneficialOwnerFormSchema,
  fields: [
    {
      name: 'individuals',
      type: FieldType.CUSTOM,
      CustomComponent: BeneficialOwnerField
    }
  ]
})
